import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "evenodd" }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "currentColor",
            d: "M8 1.333c3.682 0 6.667 2.985 6.667 6.667S11.682 14.667 8 14.667 1.333 11.682 1.333 8 4.318 1.333 8 1.333zm0 1C4.87 2.333 2.333 4.87 2.333 8S4.87 13.667 8 13.667 13.667 11.13 13.667 8 11.13 2.333 8 2.333zm0 8.5c.253 0 .462.188.495.432l.005.068v.334c0 .276-.224.5-.5.5-.253 0-.462-.188-.495-.432l-.005-.068v-.334c0-.276.224-.5.5-.5zm0-7c1.244 0 2.252 1.009 2.252 2.253 0 .43-.123.85-.353 1.21l-.09.133-1.155 1.553c-.08.107-.13.233-.147.365l-.006.1c0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-.335.094-.661.27-.943l.08-.118 1.154-1.553c.16-.216.247-.478.247-.747 0-.692-.56-1.253-1.252-1.253-.696 0-1.193.332-1.553 1.055-.123.247-.423.348-.67.225-.247-.122-.348-.422-.225-.67C6.075 4.39 6.91 3.833 8 3.833z",
            transform: "translate(-370 -549) translate(370 549)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }